export enum MainLayoutSectionWidth {

	WIDTH_WIDE = 'WIDTH_WIDE',
	WIDTH_NARROW = 'WIDTH_NARROW'

}
